'use strict';

// Sass Import
import '../Sass/style.scss';

import './module/tabFront';
import './module/tabSpecial';
import './module/slider.ts';
import './module/ham.ts';
